import { AlignmentType, BorderStyle, HeadingLevel, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx";


export const frameworkHeading = new Paragraph({
    spacing: { before: 150, after: 100 },
    children: [new TextRun({
        text: "7.  Framework and tools used for Audit",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})

export const framework = new Paragraph({
    spacing: { before: 250, after: 100 },
    children: [new TextRun({
        text: "7.1   Framework",
        // bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
})

export function frameworkText(certInApplicationName, certInCustomerName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        spacing: { line: 276, before: 250, after: 200 },
        alignment: AlignmentType.JUSTIFIED,
        children: [
            new TextRun({
                text: `ISECURION used OWASP and NIST frameworks to execute the ${certInApplicationName} Web Application belonging ${certInCustomerName}`,
                size: 22,
                font: "Calibri",
                color: '000000',
                italics: false
            }),
        ],
    })
}

export const tools = new Paragraph({
    spacing: { before: 450, after: 300 },
    children: [new TextRun({
        text: "7.2   Tools",
        // bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
})

export const toolsTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 450 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 30, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 110, after: 110 },
                            indent: { left: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Vulnerability Scanners",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "DDD9C3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    width: { size: 70, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.LEFT,
                    children: [
                        new Paragraph({
                            spacing: { before: 110, after: 110 },
                            indent: { left: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Acunteix, Burpsuite pro, Nikto Scanner, Sql Map, Dirbuster.",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: false,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "C6D9F1" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 110, after: 110 },
                            indent: { left: 60 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Exploitation Tools",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "DDD9C3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: { left: 60 },
                            spacing: { before: 110, after: 110 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Metasploit, Kalilinux, Python scripts.",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "C6D9F1" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),
    ]
})

export const areaCovered = new Paragraph({
    spacing: { before: 450, after: 300 },
    children: [new TextRun({
        text: "7.3   Area Covered Security Audit",
        // bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
})

export const areaCoveredText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The following tests are conducted as part of the Security Audit:",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const coveredPoint1 = new Paragraph({
    indent: { left: 600, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Application Fingerprinting",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const coveredPoint2 = new Paragraph({
    indent: { left: 600, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Passive and Active testing",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})


export const coveredPoint3 = new Paragraph({
    indent: { left: 600, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "OWASP top 10 2025",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})
export const coveredPoint4 = new Paragraph({
    indent: { left: 600, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Vulnerability Identification and Analysis",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})

export const coveredPoint5 = new Paragraph({
    indent: { left: 600, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Exploitation of Vulnerabilities",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})


export const coveredPoint6 = new Paragraph({
    indent: { left: 600, right: 600 },
    spacing: { line: 276, after: 25 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "SQL Injection",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})
export const coveredPoint7 = new Paragraph({
    indent: { left: 600, right: 600 },
    spacing: { line: 350, },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "HTTP methods",
            size: 22,
            font: "Calibri",
            bullet: { level: 0 },
            color: '000000',
            italics: false
        })
    ]
})
